import React from 'react'

import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'

import ProfileFormProgress from './ProfileFormProgress'
import ProfileFormSteps from './ProfileFormSteps'
import MobileProfileForm from './mobile'

import ProfileFormProvider from 'utils/providers/ProfileFormProvider'
import withMobile from 'utils/hocs/withMobile'
import { StickyButtons } from './helpers'
import ProfileFormHeader from './ProfileFormHeader'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    minHeight: '100vh',
  },
  container: {
    width: 720,
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    '& > form': {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
  },
  support: {
    flexShrink: '0',
    position: 'relative',
  },
  wrapper: {
    padding: '40px 20px 0px 20px',
    flexGrow: '1',
    display: 'flex',
    flexDirection: 'column',
  },
}))

const ProfileForm = () => {
  const classes = useStyles()

  return (
    <ProfileFormProvider>
      <Grid
        container
        flexDirection="column"
        alignItems="center"
        className={classes.root}
      >
        <ProfileFormHeader />
        <Grid className={classes.container} mb={2}>
          <ProfileFormProgress />
          <Grid className={classes.wrapper}>
            <Grid className={classes.content}>
              <ProfileFormSteps />
            </Grid>
          </Grid>
        </Grid>
        <StickyButtons />
      </Grid>
    </ProfileFormProvider>
  )
}

export default withMobile({
  DesktopComponent: ProfileForm,
  MobileComponent: MobileProfileForm,
})
